const getTitle = (title, required) => (required ? `${title} *` : title);

export default getTitle;
